export default "__VITE_ASSET__CtMoJ1y___"